import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { catMap } from "@/lib/categories";

export default function AdminSocial() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/social-allowed").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  const copy = (it) => {
    navigator.clipboard?.writeText(`${window.location.origin}/shpallje/${it.id}`).then(() => toast.success("Linku u kopjua"));
  };
  if (!items) return <p className="text-sm text-slate-400 py-6 text-center">Duke ngarkuar...</p>;
  return (
    <div data-testid="admin-social" className="space-y-2">
      <p className="text-xs text-slate-500">{items.length} biznese lejojnë të shfaqen në rrjetet sociale.</p>
      {items.map((it) => (
        <div key={it.id} data-testid={`admin-social-${it.id}`} className="flex items-center gap-3 bg-white rounded-2xl p-3 border border-slate-100">
          <div className="w-12 h-12 rounded-xl bg-slate-100 overflow-hidden shrink-0">{it.image && <img src={it.image} alt="" className="w-full h-full object-cover" />}</div>
          <button onClick={() => nav(`/shpallje/${it.id}`)} className="flex-1 min-w-0 text-left">
            <p className="font-semibold text-sm text-slate-900 truncate">{it.title}</p>
            <p className="text-xs text-slate-500 truncate">{catMap[it.category]?.label || it.category} · {it.city}{it.country ? `, ${it.country}` : ""}</p>
            <p className="text-xs text-slate-400 truncate">{it.owner_name}{it.phone ? ` · ${it.phone}` : ""}</p>
          </button>
          <button data-testid={`admin-social-copy-${it.id}`} onClick={() => copy(it)} className="w-9 h-9 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0"><Copy className="w-4 h-4" /></button>
        </div>
      ))}
      {!items.length && <p className="text-sm text-slate-400 py-6 text-center">Ende asnjë biznes.</p>}
    </div>
  );
}
